import React from 'react'

import { Banner } from './Banner'
const Home = () => {
  return (
   <Banner />
  )
}

export default Home